import api from '../../../api/api';
import { StudyEventFormDataSourceProps } from '../../../screens/study/StudyEventFormDataSource';
import { log } from '../../../tools/LogHelper';
import { DynamicFormContextState } from '../../DynamicFormContext';
import { ActionPlugin } from '../ActionPlugin';

export interface SendEmailAction {
  dataSource?: string;
  value?: string;
  emailIfAnyAnswerPresent?: boolean;
  sendToOrganizationStudyCoordinators?: boolean;
  to?: string;
  subject?: string;
  emailBody?: string;
}

export const SendEmailActionPlugin: ActionPlugin<SendEmailAction> = {
  type: 'SendEmailAction',
  validate: () => true,
  action: async (state, params) => {
    if (!state.context?.studyParticipantId) {
      console.error('SendEmailAction: No studyParticipantId specified');
      return;
    }
    const context = state.context as DynamicFormContextState<
      any,
      any,
      StudyEventFormDataSourceProps
    >;
    const { dataSourceContext, formValues } = context;
    if (!dataSourceContext?.participantEventId) {
      console.error(
        'SendEmailAction: dataSourceContext.participantEventId not provided.'
      );
      return;
    }
    const { participantEventId, occurrenceCount } = dataSourceContext;
    const {
      dataSource,
      value,
      emailIfAnyAnswerPresent,
      sendToOrganizationStudyCoordinators,
      to,
      subject,
      emailBody
    } = params ?? {};
    if (!dataSource && !emailIfAnyAnswerPresent) {
      log('SendEmailAction: data source not specified.');
      return;
    }
    if (dataSource) {
      if (
        String(formValues[dataSource]) !== String(value) &&
        !emailIfAnyAnswerPresent
      ) {
        return;
      }
      log('SendEmailAction: found value match.');
    }
    await api.post(
      `study-participants/${state.context.studyParticipantId}/notify`,
      {
        participantEventId,
        occurrenceCount,
        dataSource,
        value: dataSource ? formValues[dataSource] : value,
        emailIfAnyAnswerPresent,
        sendToOrganizationStudyCoordinators,
        to,
        subject,
        emailBody
      }
    ).response;
  }
};
